const CACHE_BREAK_V = '202405241048';
export const createFigsFontFaces = (host = '') => `
  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-regular.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-regular.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-semi-bold.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-semi-bold.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-semi-bold-italic.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-semi-bold-italic.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-bold.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-bold.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-black.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-black.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Figs;
    src: url('${host}/static/fonts/FIGS-black-italic.woff2?v=${CACHE_BREAK_V}') format('woff2'), url('${host}/static/fonts/FIGS-black-italic.woff?v=${CACHE_BREAK_V}') format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }
`;
//# sourceMappingURL=figs-font.js.map